import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { DollarSign, Clock, Lock } from "lucide-react";

const problems = [
  {
    title: "No Surprise Bills",
    description:
      "Serverless platforms (Vercel, Netlify, Cloudflare) charge per request, per function, per GB. A viral launch or a rogue scraping bot can turn a $20/month plan into a $600 invoice overnight. With VPS servers, costs are fixed and predictable.",
    icon: <DollarSign className="h-8 w-8 text-primary" />,
    color: "text-red-500"
  },
  {
    title: "No DevOps Needed",
    description:
      "Deploying your app in production requires learning AWS, Docker, Nginx, LetsEncrypt, Terraform, CI/CD, and more. DollarDeploy handles all of that automatically - so you can ship the same day you build.",
    icon: <Clock className="h-8 w-8 text-primary" />,
    color: "text-blue-500"
  },
  {
    title: "Avoid Vendor Lock-in",
    description:
      "Once you've built your sophisticated infrastructure on one cloud, it's extremely difficult to migrate to another cloud or your own private infrastructure. Deploying with DollarDeploy gives you the freedom to move between clouds and scale as you grow.",
    icon: <Lock className="h-8 w-8 text-primary" />,
    color: "text-purple-500"
  }
];

export const Problems = () => {
  return (
    <section id="problems" className="container pt-24 pb-8 md:pb-16 space-y-8 md:space-y-16">
      <div className="text-center">
        <h2 className="font-serif text-[clamp(36px,5.5vw,56px)] leading-[1.05] tracking-tight font-normal mb-4 text-foreground text-balance">
          Focus on building, not&nbsp;
          <em className="text-primary">deploying</em>
        </h2>
        <p className="text-xl text-muted-foreground md:w-3/4 mx-auto">
          AI made building apps easier. We solve getting your apps running great for your
          users.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {problems.map(({ title, description, icon }) => (
          <Card key={title} className="bg-muted/50 border">
            <CardHeader className="flex flex-row items-center gap-4 pt-2">
              {icon}
              <CardTitle className="text-xl font-bold">{title}</CardTitle>
            </CardHeader>
            <CardContent className="text-muted-foreground">{description}</CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};
